import React, { type ReactNode } from 'react';
import Flag from '@atlaskit/flag';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import { B300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

type RefreshBannerProps = Readonly<{
	actionLabel: ReactNode;
	reloadEP: () => void;
	title: ReactNode;
}>;

const RefreshBanner = ({ reloadEP, title, actionLabel }: RefreshBannerProps): React.JSX.Element => (
	<Flag
		icon={
			<StatusSuccessIcon
				spacing="spacious"
				color={token('color.icon.information', B300)}
				label="Info"
			/>
		}
		id="refreshBanner"
		title={title}
		actions={[{ content: actionLabel, onClick: reloadEP }]}
	/>
);

export default RefreshBanner;
